"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var React = _interopRequireWildcard(require("react"));

var _react2 = require("@emotion/react");

var _MetrocommonTriangle = require("./MetrocommonTriangle");

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: #fff;\n  margin: 30px 0;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-top: 20px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  transition: rotate .3s ease-out;\n  rotate: 90deg;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  transition: rotate .3s ease-out;\n  rotate: 0deg;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function toggleVisibility(currentState, setActive) {
  if (currentState === true) {
    return setActive(false);
  }

  return setActive(true);
}

var accordionHeaderStyle = (0, _react2.css)(_templateObject());
var iconStyle = (0, _react2.css)(_templateObject2());
var activeIconStyle = (0, _react2.css)(_templateObject3(), iconStyle);
var contentStyle = (0, _react2.css)(_templateObject4());
var accordionDividerStyle = (0, _react2.css)(_templateObject5());

var Accordion = function Accordion(_ref) {
  var triangleColor = _ref.triangleColor,
      title = _ref.title,
      children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, ["triangleColor", "title", "children"]);

  var _React$useState = React.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      isActive = _React$useState2[0],
      setActive = _React$useState2[1];

  return (0, _react2.jsx)("div", props, (0, _react2.jsx)("header", {
    css: accordionHeaderStyle,
    onClick: function onClick() {
      return toggleVisibility(isActive, setActive);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') {
        toggleVisibility(isActive, setActive);
      }
    },
    role: "button",
    tabIndex: 0
  }, title, (0, _react2.jsx)(_MetrocommonTriangle.MetrocommonTriangle, {
    color: triangleColor,
    css: isActive ? activeIconStyle : iconStyle
  })), isActive ? (0, _react2.jsx)("div", {
    css: contentStyle
  }, children) : '', (0, _react2.jsx)("hr", {
    css: accordionDividerStyle
  }));
};

exports.Accordion = Accordion;